import {
  Alert,
  Button,
  Col,
  DesignTokens,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useFormikContext } from "formik";
import {
  DatePickerField,
  DisplayFormErrors,
  DrawerFooterContent,
  VerticalForm,
} from "melco-shared-logic";
import { Drawer as DrawerType } from "../../../../hooks/drawer/useGenericDrawer";
import { DisplayBlankDropDown } from "../../../dropdown/DisplayBlankDropDown";
import { DisplayLevelSubscriptionDropDown } from "../../../dropdown/DisplayLevelSubscriptionDropDown";
import { useState } from "react";
import dayjs from "dayjs";
import { formatUTCDate } from "../../../../helper/dateHelper";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const AlertWrapper = styled.div`
  margin-bottom: 25px;
`;

const { spacings } = DesignTokens;

type DisplayChangeLevelLicenseLevelProps = {
  referenceDrawer?: DrawerType;
  stepback: any;
  currentLicense: any;
  //callBackForVersionDisplayValue:any;
  callBackForSubscriptionCodeDisplayValue: any;
};

export const DisplayChangeLevelLicenseLevel: React.FC<
  DisplayChangeLevelLicenseLevelProps
> = ({ stepback, currentLicense, callBackForSubscriptionCodeDisplayValue }) => {
  const { t } = useTranslation();

  const [productIsSubscription] = useState(
    currentLicense?.is_subscription ?? false
  );
  const { submitForm, setFieldValue } = useFormikContext();

  const callBackForSubscription = (v: any, options: any) => {
    callBackForSubscriptionCodeDisplayValue(options.label);
  };

  return (
    <>
      <div>
        <FullWidthSpace direction="vertical" size="small">
          <DisplayFormErrors />
          {currentLicense?.is_pending && <AlertWrapper>
            <Alert
              type="warning"
              style={{ width: "100%" }}
              message={t("licensemanager.changelevel.warning.message")}

              withBackground
            />
          </AlertWrapper>
          }
          <Title level={4}>
            {t("licensemanager.changelevel.form.licensedetails")}
          </Title>

          <Row gutter={[spacings.middle, 0]}>
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("licensemanager.changelevel.form.melco_customer_id")}
                  content={currentLicense.melco_customer_id}
                  fallback={t("licensemanager.changelevel.form.fallback")}
                />
                <LabeledItem
                  label={t("licensemanager.changelevel.form.product")}
                  content={currentLicense.product_name}
                  fallback={t("licensemanager.changelevel.form.fallback")}
                />

                <LabeledItem
                  label={t("licensemanager.changelevel.form.version")}
                  content={currentLicense.product_version_number}
                  fallback={t("licensemanager.changelevel.form.fallback")}
                />

                {/* <LabeledItem
                    label={t("licensemanager.changelevel.form.level")}
                    content={currentLicense.product_level_name}
                    fallback={t("licensemanager.changelevel.form.fallback")}
                  /> */}
              </Space>
            </Col>
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("licensemanager.changelevel.form.owner")}
                  content={
                    <>
                      <Row>{currentLicense.master_user_name}</Row>
                      <Row>{currentLicense.master_name}</Row>
                    </>
                  }
                  fallback={t("licensemanager.changelevel.form.fallback")}
                />
                <LabeledItem
                  label={t("licensemanager.changelevel.form.assigneduser")}
                  content={
                    <>
                      <Row>{currentLicense.assigned_user_name}</Row>
                      <Row>{currentLicense.assigned_name}</Row>
                    </>
                  }
                  fallback={t("licensemanager.changelevel.form.fallback")}
                />
                <LabeledItem
                  label={t("licensemanager.changelevel.form.level")}
                  content={currentLicense.product_level_name}
                  fallback={t("licensemanager.changelevel.form.fallback")}
                />
                {productIsSubscription && (
                  <>
                    <LabeledItem
                      label={t("licensemanager.changelevel.form.subscription_start_date")}
                      content={
                        dayjs(
                          currentLicense?.subscription_start_date ?? ""
                        ).isValid()
                          ? formatUTCDate(
                            currentLicense?.subscription_start_date
                            , "MM/DD/YYYY")
                          : ""
                      }
                      fallback={t("global.fallback.empty")}
                    />
                    <LabeledItem
                      label={t("licensemanager.changelevel.form.renewes_on")}
                      content={
                        dayjs(currentLicense?.renewal_date ?? "").isValid()
                          ? formatUTCDate(currentLicense?.renewal_date, "MM/DD/YYYY")

                          : ""
                      }
                      fallback={t("global.fallback.empty")}
                    />
                  </>
                )}
              </Space>
            </Col>
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("licensemanager.changelevel.form.serial_number")}
                  content={currentLicense.serial_number}
                  fallback={t("licensemanager.changelevel.form.fallback")}
                />
                <LabeledItem
                  label={t("licensemanager.changelevel.form.language")}
                  content={
                    currentLicense.language && currentLicense.language !== ""
                      ? t(`language.${currentLicense.language}` as any)
                      : ""
                  }
                  fallback={t("licensemanager.changelevel.form.fallback")}
                />
              </Space>
            </Col>
          </Row>

          <div>
            <VerticalForm>
              <Title level={4}>
                {t("licensemanager.changelevel.form.title.changes")}
              </Title>
              {/* {currentLicense.product_code && <DisplayProductVersionsDropDown
            selectedProductValue={currentLicense.product_code}
            callbackFn={callBackForVersion}
          /> } */}

              {currentLicense.product_code &&
                currentLicense.product_version_number ? (
                <DisplayLevelSubscriptionDropDown
                  label={t("licensemanager.changelevel.form.level")}
                  selectedProductValue={currentLicense.product_code}
                  selectedVersionValue={currentLicense.product_version_number}
                  callbackFn={callBackForSubscription}
                />
              ) : (
                <DisplayBlankDropDown
                  name="subscription_code"
                  label={t("licenses.basic.search.level.title")}
                />
              )}
              {/* {productIsSubscription ? (
                <DatePickerField
                  label={
                    currentLicense?.renewal_date
                      ? t("licensemanager.changelevel.form.renewes_on")
                      : t("licensemanager.changelevel.form.subscription_start_date")
                  }

                  name="subscription_start_date"
                  disabledDate={(current) => {
                    const today = dayjs().startOf("day");

                    if (!current) return true;

                    const checkDate = current.startOf("day");

                    // Always disable dates before today
                    if (checkDate.isBefore(today)) {
                      return true;
                    }

                    const renewalDate = currentLicense?.renewal_date
                      ? dayjs(formatUTCDate(currentLicense.renewal_date)).startOf("day").toDate()
                      : null;

                    const subscriptionStartDate =
                      currentLicense?.subscription_start_date
                        ? dayjs(formatUTCDate(currentLicense.subscription_start_date)).startOf(
                          "day"
                        ).toDate()
                        : null;

                    // If renewal date exists, disable dates before it (allow same day)
                    if (renewalDate && (checkDate.isBefore(renewalDate) || checkDate.isSame(renewalDate))) {
                      return true;
                    }

                    // Else, if subscription date exists, disable dates before it
                    if (
                      !renewalDate &&
                      subscriptionStartDate &&
                      (checkDate.isBefore(subscriptionStartDate) || checkDate.isSame(subscriptionStartDate))
                    ) {
                      return true;
                    }

                    // All good
                    return false;
                  }}

                  onChange={(date, dateString) => {
                    setFieldValue(
                      "subscription_start_date",
                      date ? dayjs(date).startOf("day").toDate() : null
                    );
                    // setCreateConfirmDetailsToDisplay({
                    //   ...createConfirmDetailsToDisplay,
                    //   subscription_start_date: dateString,
                    // });
                  }}
                />
              ) : null} */}

              {productIsSubscription ? (
                <DatePickerField
                  label={
                    currentLicense?.renewal_date
                      ? t("licensemanager.changelevel.form.renewes_on")
                      : t("licensemanager.changelevel.form.subscription_start_date")
                  }

                  name="subscription_start_date"

                  // Disable all dates before the minimum allowed date
                  disabledDate={(current) => {
                    const today = dayjs().startOf("day");

                    if (!current) return true;

                    const checkDate = current.startOf("day");

                    // Always disable dates before today
                    if (checkDate.isBefore(today)) {
                      return true;
                    }

                    // Parse the renewal and subscription dates from the API
                    const renewalDate = currentLicense?.renewal_date
                      ? dayjs(formatUTCDate(currentLicense.renewal_date)).startOf("day").toDate()
                      : null;

                    const subscriptionStartDate = dayjs(
                      formatUTCDate(currentLicense.subscription_start_date)
                    ).startOf("day").toDate();

                    //  Business Logic:
                    // - If renewal_date exists, disable dates <= renewal_date
                    // - Else (renewal_date is null), use subscription_start_date
                    //   which is guaranteed to be present and NOT in the past

                    // If renewal date exists, only allow dates *after* it
                    if (renewalDate && (checkDate.isBefore(renewalDate) || checkDate.isSame(renewalDate))) {
                      return true;
                    }

                    // If no renewal date, fallback to subscription start date (always exists)
                    // Disallow selection of the same day or any earlier date
                    if (!renewalDate && (checkDate.isBefore(subscriptionStartDate) || checkDate.isSame(subscriptionStartDate))) {
                      return true;
                    }

                    //  Valid date
                    return false;
                  }}

                  // When user selects a date, store it as start of the day (local time)
                  onChange={(date) => {
                    setFieldValue(
                      "subscription_start_date",
                      date ? dayjs(date).startOf("day").toDate() : null
                    );
                  }}
                />
              ) : null}
            </VerticalForm>
          </div>
        </FullWidthSpace>
        <DrawerFooterContent>
          <Row>
            <Col xs={24} md={12}>
              <Button
                style={{ minWidth: "80px" }}
                key={"back-btn"}
                type="primary"
                onClick={stepback}
              >
                {t("licensemanager.buttons.back")}
              </Button>
            </Col>
            <Col
              style={{ display: "flex", justifyContent: "flex-end" }}
              xs={24}
              md={12}
            >
              <Right>
                <Button
                  style={{ minWidth: "80px" }}
                  key="add-user-button"
                  type="primary"
                  onClick={() => submitForm()}
                >
                  {t("licensemanager.buttons.next")}
                </Button>
              </Right>
            </Col>
          </Row>
        </DrawerFooterContent>
      </div>
    </>
  );
};
